var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled, { css } from "styled-components";
import id from "@irati/utils/id";
import ProfilePicture from "@irati/ui/src/ProfilePicture";
import getUserName from "@irati/identity/helpers/user/firstnameLastname";
import Flex from "@irati/ui/src/Flex";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
var Name = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ", "\n"], ["\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: ", ";\n    /* Tested in recognition product as it's the longest logo. Not visible on mobile */\n    ", "\n    ", "\n    ", "\n  "], ["\n    margin-right: ", ";\n    /* Tested in recognition product as it's the longest logo. Not visible on mobile */\n    ", "\n    ", "\n    ", "\n  "])), theme.spacing.one, theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["max-width: 120px;"], ["max-width: 120px;"]))), theme.mediaQueries.minWidthMedia.desktop(templateObject_2 || (templateObject_2 = __makeTemplateObject(["max-width: 200px;"], ["max-width: 200px;"]))), theme.mediaQueries.minWidthMedia.largeDesktop(templateObject_3 || (templateObject_3 = __makeTemplateObject(["max-width: 400px;"], ["max-width: 400px;"]))));
});
var UserMenuTitle = /** @class */ (function (_super) {
    __extends(UserMenuTitle, _super);
    function UserMenuTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserMenuTitle.prototype.render = function () {
        var user = this.props.user;
        var idNamespace = id("desktop", this.props);
        return (React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", minWidth: "150px" },
            React.createElement(Flex, { alignItems: "center" },
                React.createElement(ProfilePicture, { id: id("user-profile", idNamespace), user: user, marginRight: true, small: true }),
                React.createElement(Name, null, getUserName(user))),
            React.createElement(Icon, { icon: IconTypes.chevronDown, id: id("arrowDown", idNamespace) })));
    };
    return UserMenuTitle;
}(Component));
export default UserMenuTitle;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
